/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminServiceCreateInput } from "../../entities/models/AdminServiceCreateInput";
import { z } from "zod/v4";

export const modelsAdminServiceCreateInputSchema = z.object({
    "duration_minutes": z.int(),
"is_active": z.optional(z.boolean()),
"name": z.string(),
"price": z.number(),
"service_type": z.enum(["adult", "child", "adult_child"])
    }) as unknown as z.ZodType<ModelsAdminServiceCreateInput>